import { render, staticRenderFns } from "./table.vue?vue&type=template&id=508bc7fc"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('508bc7fc')) {
      api.createRecord('508bc7fc', component.options)
    } else {
      api.reload('508bc7fc', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=508bc7fc", function () {
      api.rerender('508bc7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/src/table.vue"
export default component.exports